var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.908,
    height: 16.53,
    viewBox: "0 0 17.908 16.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-leaf",
    "data-name": "Icon ionic-ios-leaf",
    d: "M20.849,18.047a8.709,8.709,0,0,1-2.4-.5,8.99,8.99,0,0,0-3.285-8.42c-3.091-2.548-7.787-.7-11.447-4.572-.852-.9-.357,10.138,4.223,14.322a8.052,8.052,0,0,0,8.373,1.619,4.793,4.793,0,0,0,1.666-1.459,12.633,12.633,0,0,0,2.669.611C21.279,19.721,21.6,18.163,20.849,18.047Zm-3.952.319a20.271,20.271,0,0,1-8.14-5.433.176.176,0,0,1,.237-.258,26.179,26.179,0,0,0,8.321,4.645A1.605,1.605,0,0,1,16.9,18.365Z",
    transform: "translate(-3.376 -4.499)",
    fill: "#2e117f"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEco);
export default __webpack_public_path__ + "static/media/eco.b88240a9ef3ed54b25d6aecb9357ca77.svg";
export { ForwardRef as ReactComponent };